import React, { Component } from 'react';
import { connect } from 'react-redux';
import Joyride from 'react-joyride';
import { customJoyrideStyles, pulseAnimationCSS, customJoyrideLocale } from '../../constants/joyrideStyles';

class NavPanelTour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      runTour: false,
      tourSteps: [],
    };
  }

  componentDidMount() {
    this.checkAndStartTour();
  }

  componentDidUpdate(prevProps) {
    // Check if location data changed
    if (prevProps.locationData !== this.props.locationData) {
      this.checkAndStartTour();
    }
  }

  checkAndStartTour = () => {
    const { locationData, allowTeamFeed, allowScheduleUpload } = this.props;
    const hasSeenNavPanelTour = sessionStorage.getItem('hasSeenNavPanelTour');
    
    // Only start if not seen before and location data is available
    if (!hasSeenNavPanelTour && locationData) {
      setTimeout(() => {
        this.generateNavPanelTourSteps();
        this.setState({ runTour: true });
      }, 1000); // Start after 1 second
    }
  };

  generateNavPanelTourSteps = () => {
    const { locationData, allowTeamFeed, allowScheduleUpload } = this.props;
    
    const steps = [
      {
        target: '[data-id="nav-schedulecalendar"]',
        content: 'Open your schedule calendar to manage your shifts and availability.',
        placement: 'right',
        disableBeacon: true,
      },
      {
        target: '[data-id="nav-requests"]',
        content: 'Manage your team’s shift and time-off requests, and view shift records.',
        placement: 'right',
        disableBeacon: true,
      },
      {
        target: '[data-id="nav-usermanagement"]',
        content: 'Manage your team, departments, skills, and access permissions.',
        placement: 'right',
        disableBeacon: true,
      }
    ];

    // Conditional steps based on feature flags
    if (allowTeamFeed) {
      steps.push({
        target: '[data-id="nav-community"]',
        content: 'Stay connected with your team in the community feed.',
        placement: 'right',
        disableBeacon: true,
      });
    }

    if (allowScheduleUpload) {
      steps.push({
        target: '[data-id="nav-scheduler"]',
        content: 'Use the scheduler to import shifts into your schedule.',
        placement: 'right',
        disableBeacon: true,
      });
    }

    if (locationData && locationData.plan_id !== null) {
      steps.push({
        target: '[data-id="nav-settings"]',
        content: 'Access your account settings and preferences.',
        placement: 'right',
        disableBeacon: true,
      });
    }

    // Filter out steps where the target element doesn't exist
    const validSteps = steps.filter(step => {
      const element = document.querySelector(step.target);
      return element !== null;
    });

    this.setState({ tourSteps: validSteps });
  };

  handleTourCallback = (data) => {
    const { status, action } = data;
    
    if (status === "finished" || status === "skipped" || action === "close") {
      // Mark tour as completed
      sessionStorage.setItem('hasSeenNavPanelTour', 'true');
      this.setState({
        runTour: false,
        tourSteps: [],
      });
    }
  };

  render() {
    const { runTour, tourSteps } = this.state;

    if (tourSteps.length === 0) {
      return null;
    }

    return (
      <>
        {/* CSS for pulse animation */}
        <style>{pulseAnimationCSS}</style>
        
        {/* NavPanel Tour */}
        <Joyride
          steps={tourSteps}
          run={runTour}
          continuous
          showProgress
          showSkipButton
          callback={this.handleTourCallback}
          styles={customJoyrideStyles}
          locale={customJoyrideLocale}
          title="Navigation Guide"
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const appLocation = state.appReducer.location || {};
  const locationReducer = state.locationReducer || {};
  const locationData = locationReducer.location_data || null;
  
  // Extract feature flags from appReducer.location.settings
  const allowTeamFeed = appLocation.settings ? appLocation.settings.cfg__group_chat : null;
  const allowScheduleUpload = appLocation.settings ? appLocation.settings.cfg__schedule_upload : null;

  return {
    locationData,
    allowTeamFeed,
    allowScheduleUpload,
  };
};

export default connect(mapStateToProps)(NavPanelTour); 